export namespace PaidUp {
  export interface SubmitData {
    reason: string | null
    requestPaidUpPeriod: string
  }
}
